import type { Feature } from '@luna/gatekeeper';

export const creditLimitChange: Feature = {
    enabled: false,
    _description: 'Enable redirection based credit limit change',
};
